import { BaseEntity } from '../../models';
import { Estado } from '../estado';
import { CidadeSubRegiao } from './sub-regiao';

export class Cidade implements BaseEntity {
    id: number;
    codigo: string;
    nome: string;
    codigoIbge: number;
    idEstado: number;
    estado: Estado;
    idMicrorregiao: number;
    idRegiaoGeograficaImediata: number;
    populacao: number;
    possuiSubRegioes: boolean;
    classificacao: number;
    subRegioes: CidadeSubRegiao[];
    /** Se a cidade foi cadastrada manualmente por algum usuário */
    cadastroManual: boolean;

    constructor(props: Partial<Cidade>) {
        Object.assign(this, props);
    }
}
